const heroSwiper = new Swiper('.home__hero', {
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  loop: true,
  keyboard: true,
  effect: 'fade',
  autoplay: {
    delay: 3000,
    disableOnInteraction: true,
  },
});

const carrouselActualites = new Swiper('.carrousel-actualites__swiper', {
  slidesPerView: 1,
  spaceBetween: 20,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  keyboard: true,
  breakpoints: {
    576: {
      slidesPerView: 2,
    },
    992: {
      slidesPerView: 3,
      spaceBetween: 40,
    },
  },
});
